import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { StructuredOperationFileModel } from "../../../model/domain/StructuredOperationFileModel";
import { SnackbarService } from "../../../services/snackbar.service";
import { TicketService } from "../../../services/ticket.service";

@Component({
  selector: "app-operation-structured-reservation-dialog",
  templateUrl: "./operation-structured-comment-dialog.component.html",
  styleUrls: ["./operation-structured-comment-dialog.component.css"],
})
export class OperationStructuredCommentDialogComponent {
  fileId: number;
  commentList: StructuredOperationFileModel[];
  newComment: string = "";
  model: StructuredOperationFileModel;
  structuredOperationFileAnnotation: StructuredOperationFileModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private service: TicketService,
    private snackBarService: SnackbarService
  ) {
    this.model = data.model;
    this.structuredOperationFileAnnotation = new StructuredOperationFileModel();
    this.getComments();
  }

  getComments() {
    this.service.StructuredOperations.getComments(
      this.model.ticketId
    ).subscribe((q) => {
      this.commentList = q;
    });
  }

  saveComments() {
    if (this.newComment != "") {
      this.structuredOperationFileAnnotation.comment = this.newComment;
      this.structuredOperationFileAnnotation.fileId = this.model.fileId;
      this.structuredOperationFileAnnotation.ticketId = this.model.ticketId;
      this.structuredOperationFileAnnotation.tempId = this.model.tempId;
      this.structuredOperationFileAnnotation.subTypeAssetId =
        this.model.subTypeAssetId;
      this.structuredOperationFileAnnotation.workflowStatusId =
        this.model.workflowStatusId;

      this.service.StructuredOperations.saveComments(
        this.structuredOperationFileAnnotation
      ).subscribe((r) => {
        this.structuredOperationFileAnnotation.fileId = r.fileId;
        this.getComments();
        this.newComment = "";
        this.snackBarService.open("Anotação salva com sucesso!");
      });
    } else {
      this.snackBarService.open("Não é possível salvar uma anotação vazia.");
    }
  }
}
